import styled from 'styled-components';

const ModalHeading = styled.h2`
  margin-top: 0;
  top: 0;
  border-bottom: 1px solid #eeeaea;
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  line-height: 1.38;
  padding-bottom: 15px;
  text-align: center;
  width: 100%;
`;

export default ModalHeading;
